import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { DataTableFilterMeta } from "primereact/datatable";

type TechFilterState = {
  filters: DataTableFilterMeta;
  setFilters: (filters: DataTableFilterMeta) => void;
  clear: () => void;
};

export const useFilterTechStore = create<TechFilterState>()(
  persist(
    (set) => ({
      filters: {},
      setFilters: (filters) => set({ filters }),
      clear: () => set({ filters: {} }),
    }),
    { name: "tech-filters" }
  )
);
